import React from "react";
import "./possibility.css";
import possibilityImg from "../../assets/possibility.png";
import { Cta } from "../../components";
import BigTitle from "../../components/bigTitle/BigTitle";

const Possibility = () => {
  return (
    <div className="gpt3__possibility-container" id="features">
      <div className="gpt3__possibility-row">
        <div className="gpt3__possibility-imgContainer">
          <img src={possibilityImg} alt="Possibility image" />
        </div>
        <div className="gpt3__possibility-textContainer">
          <p className="gpt3__possibility-blueSubtitle">
            Request Early Access to Get Started
          </p>
          <h5 className="gpt3__possibility-titleBackground">
            The possibilities are beyond your imagination
          </h5>
          <p>
            Yet bed any for travelling assistance indulgence unpleasing. Not
            thoughts all exercise blessing. Indulgence way everything joy
            alteration boisterous the attachment. Party we years to order allow
            asked of.
          </p>
          <a href="#">Request Early Access to Get Started</a>
        </div>
      </div>

      <Cta
        subtitle="Request Early Access to Get Started"
        title="Register today & start exploring the endless possibilities."
        btnLink="#"
        btnText="Get Started"
      />
      <BigTitle
        id="blog"
        modifier="left-short"
        title={["A lot is happening,", "We are blogging about it."]}
      />
    </div>
  );
};

export default Possibility;
